//types
import { Value } from 'shared/components/Filter/types';

export const getAllIds = (values: Value[]) => {
  let ids: string[] = [];

  values.forEach((value) => {
    if (value.children?.length) {
      const childIds = getAllIds(value.children);
      ids.push(...childIds);
    } else {
      ids.push(value.id);
    }
  });

  return ids;
};
